// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1ajNT","amount":"Amount_amount__3ZFum","tip":"Amount_tip__oum-B","tipHeader":"Amount_tipHeader__13V_r","tipsWrap":"Amount_tipsWrap__je0bu"};